import { useState, useEffect } from "react";
import * as s from './style'


type Props = {
    readonly name: string
}

const Filter: React.FC<Props> = ({name}) => {

    const [color, setColor] = useState('#FF8B00')
    const [bg, setBg] = useState('#fff')

    useEffect(()=>{
        bg === '#fff' ? setColor('#FF8B00') : setColor('#fff')
    },[bg])

    return(
        <s.filter id='click' style={{'background':`${bg}`, 'color':`${color}`}}
        onClick={() => setBg(bg === "#fff" ? "#FF8B00" : "#fff")}
        className='filter'>
            {name}
        </s.filter>
    )
}

export default Filter